import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold font-heading text-background-50">叮当漫画</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-5">热门分类</h4>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-5">快速链接</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">版权声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-5">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-mail-line text-base"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-phone-line text-base"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-map-pin-line text-base"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer" rel="nofollow">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 叮当漫画网 版权所有 | 京ICP备2024XXXXXXXX号
            </p>
            <p className="text-xs text-background-50/40">
              用心做好每一页漫画，让阅读成为一种享受
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}